var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCircleBlue6({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#166bcd"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M10.709 17.113q0-1.293.185-2.554.195-1.271.666-2.389a6.2 6.2 0 0 1 1.323-1.99q.85-.87 2.163-1.363 1.312-.502 3.18-.502.44 0 1.024.04.595.031.985.114V11a8 8 0 0 0-.882-.143 7 7 0 0 0-.923-.062q-1.866 0-2.891.595a3.28 3.28 0 0 0-1.436 1.65q-.41 1.047-.482 2.441h.133q.288-.502.718-.892.441-.39 1.067-.615.625-.236 1.466-.236 1.313 0 2.276.564.964.554 1.487 1.61t.523 2.574q0 1.62-.625 2.789a4.3 4.3 0 0 1-1.774 1.794q-1.14.615-2.707.615-1.149 0-2.143-.39a4.8 4.8 0 0 1-1.744-1.21q-.748-.81-1.169-2.04-.42-1.24-.42-2.933m5.414 4.04q.933 0 1.518-.636t.584-1.99q0-1.096-.513-1.722-.503-.636-1.527-.636-.698 0-1.23.318a2.25 2.25 0 0 0-.811.79 1.85 1.85 0 0 0-.287.974q0 .523.144 1.035.143.513.43.933a2.3 2.3 0 0 0 .708.677q.43.257.984.257"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCircleBlue6);
export default __webpack_public_path__ + "static/media/icon-circle-blue-6.f1206d41304a52dd8cfe5a432eea81d8.svg";
export { ForwardRef as ReactComponent };